var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.polygon)?_c('div',{staticClass:"texture",style:(`clip-path: polygon(${_vm.polygon});`)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }